<template>
    <div id="app">
        <NavigationMenu />
        <router-view /> <!-- Dynamically loads HomePage, ArtistsSeenPage, etc. -->
    </div>
</template>

<script>
    import NavigationMenu from './components/NavigationMenu.vue';

    export default {

        components: {
            NavigationMenu
        }
    }
</script>
